export function performMinMaxValidation(betragElement) {
  betragElement.setCustomValidity("");
  if (betragElement.checkValidity()) {
    const value = window.parseFloat(betragElement.value.replace(",", "."));
    const min = window.parseInt(betragElement.getAttribute("min"));
    const max = window.parseInt(betragElement.getAttribute("max"));
    if (!(min <= value && max >= value)) {
      betragElement.setCustomValidity(betragElement.getAttribute("title"));
    }
  }
}

export function betragInCent(betragElement) {
  let valueAsString = betragElement.value;
  if (valueAsString.includes(",") || valueAsString.includes(".")) {
    valueAsString = valueAsString.replace(".", "").replace(",", "");
  } else {
    valueAsString += "00";
  }
  return window.parseInt(valueAsString);
}
